import { useGroupOptions } from '@/hooks';
import { Autocomplete, Chip, TextField } from '@mui/material';
import { useController } from 'react-hook-form';

export function GroupCodesController({
  control,
  name,
  label,
  disabled,
  rules,
  types,
  ancestors,
}) {
  const {
    field: { value, onChange, ref },
    fieldState: { error, invalid },
  } = useController({
    name,
    control,
    rules,
  });
  const groupOptions = useGroupOptions({ types, ancestors });
  const groupBy = (option) => groupOptions?.[option].type;
  const getOptionLabel = (option) => groupOptions?.[option]?.name ?? option;

  function handleChange(_, selections) {
    onChange(selections);
  }

  function renderInput(params) {
    return (
      <TextField
        inputRef={ref}
        label={label}
        error={invalid}
        helperText={error?.message}
        {...params}
      />
    );
  }

  function renderValue(value, getTagProps) {
    return value.map((option, index) => {
      const { key, ...props } = getTagProps({ index });

      return (
        <Chip
          key={key}
          label={groupOptions?.[option]?.name}
          icon={
            <Chip
              color="primary"
              label={groupOptions?.[option]?.type}
              size="small"
            />
          }
          {...props}
        />
      );
    });
  }

  return (
    <Autocomplete
      value={value ?? []}
      fullWidth
      size="small"
      disabled={disabled}
      multiple
      onChange={handleChange}
      options={Object.keys(groupOptions || {})}
      groupBy={groupBy}
      getOptionLabel={getOptionLabel}
      // isOptionEqualToValue={(option, value) =>
      //   value ? option.value === value : false
      // }
      sx={{ minWidth: 240 }}
      renderInput={renderInput}
      renderValue={renderValue}
    />
  );
}
